import * as ng from 'angular';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';

import { Dataset } from '..';

ng.module('e360')
   .factory('pieChartFactory', pieChartFactory);

pieChartFactory.$inject = ['instanceServiceFactory'];
function pieChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(PieChart);
}

export class PieChart {
   static $inject = ['ds'];

   chart:Highcharts.ChartObject;
   onClick?:{
      (e:Highcharts.AreaClickEvent):void;
   };

   constructor(ds:Dataset, extraOptions:any = null) {
      let options = {
         chart: {
            renderTo: ds.id,
            type: 'pie'
         },
         title: {
            text: ds.title,
         },
         tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b>'
         },
         exporting: {
            filename: ds.id
         },
         plotOptions: {
            pie: {
               allowPointSelect: true,
               cursor: 'pointer',
               dataLabels: {
                  enabled: true,
                  format: '{point.percentage:.1f} %',
               },
               events: {
                  click: (e) => this.onClick(e)
               }
            }
         },
         legend: {
            symbolPadding: 15,
            verticalAlign: 'bottom',
            lineHeight: 30,
            margin: 20,
            itemDistance: 30,
            itemMarginBottom: 10
          },
         series: [{
            name: ds.title,
            showInLegend: true
         }]
      };

      if (extraOptions) {
         options = ng.merge(options, extraOptions);
      }

      this.chart = new Highcharts.Chart(options);
   }

   setData(data:any[]) {
      if (data.length > 0) {
         data = _.map(data, (obj) => {
            let vals = _.values(obj);
            return { name: vals[0], y: vals[1] };
         });
      }

      this.chart.series[0].setData(data);
   }

   onLoadStart() {
      this.chart.showLoading();
   }

   onLoadFinish() {
      this.chart.hideLoading();
   }
}

export interface PieChartFactory {
   ({ds:Dataset}):PieChart;
}
